// extracted by mini-css-extract-plugin
module.exports = {"container":"PrintableLabelLink_container__1kVxL","link":"PrintableLabelLink_link__DZoeZ"};